<template>
  <div class="status_mai">
    <button class="status_mai_btn" @click="popup_mai = !popup_mai">
      <div class="mai_icon"><i class="fas fa-coins"></i></div>
      <p class="mai_counter">{{mai.useable}}</p>
      <p class="mai_current">mai</p>
    </button>
    <transition name="mai-popup">
      <div class="mai_popup" v-if="popup_mai" @click="popup_mai = !popup_mai">
        <div class="mai_popup_wrapper">
          <button class="popup_close">
            <i class="fas fa-times"></i>
          </button>
          <div class="mai_able">
            <p class="title">使えるmai</p>
            <p class="value"><span>{{mai.useable}}</span>mai</p>
          </div>
          <div class="mai_given">
            <p class="title">貰ったmai</p>
            <p class="value"><span>{{mai.increment.give}}</span>mai</p>
          </div>
          <div class="mai_send">
            <p class="title">贈ったmai</p>
            <p class="value"><span>{{mai.decrement.send}}</span>mai</p>
          </div>
          <div class="mai_total">
            <p class="title">通算mai</p>
            <p class="value"><span>{{mai.total}}</span>mai</p>
          </div>
          <div class="popup_btn_history">
            <button>maiの履歴<i class="fas fa-chevron-right"></i></button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["mai"],
  data() {
    return {
      popup_mai: false,
    };
  },
};
</script>

<style lang="scss">
.mai-popup-enter-active,
.mai-popup-leave-active {
  transition: opacity 0.3s;
}
.mai-popup-enter,
.mai-popup-leave-to {
  opacity: 0;
}
.mai_popup {
  @include zIndex(101);
  position: fixed;
  height: 120vh;
  width: 100%;
  top: -20vh;
  left: 0;
  background-color: $fade_color;
  @include flex_c();
  &_wrapper {
    position: relative;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    min-width: 360px;
    box-shadow: 0px 0px 24px #00000060;
  }
  .popup {
    &_close {
      position: absolute;
      @include icon(16px);
      top: 10px;
      left: 10px;
      padding: 20px;
    }
    &_btn_history {
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: -16px;
      left: 0;
      button {
        margin: 0 auto;
        @include fz(16);
        padding: 6px 16px 6px 24px;
        background-color: $main_orange;
        color: #fff;
        border-radius: 30px;
        @include flex_c();
      }
      i {
        @include fz(16);
        margin-left: 14px;
      }
    }
  }
  .mai {
    &_able {
      margin: 20px 0 40px;
      p {
        text-align: center;
      }
      .title {
        display: inline-block;
        padding: 6px 10px;
        margin-bottom: 10px;
        position: relative;
        @include zIndex(0);
        &::after {
          @include pseudo(2px, calc(100% + 40px));
          background-color: $main_orange;
          top: 50%;
          left: -20px;
          @include zIndex(-2);
        }
        &::before {
          @include pseudo(100%, 100%);
          background-color: #fff;
          top: 0;
          left: 0;
          @include zIndex(-1);
        }
      }
      .value span {
        @include fz(30);
      }
    }
    &_given,
    &_send,
    &_total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid $text_black;
    }
    &_total {
      border-bottom: none;
      margin-bottom: 10px;
    }
  }
  @include sp {
    &_wrapper {
      min-width: 96%;
    }
  }
}
</style>